module.exports = __webpack_public_path__ + "img/thothAboutImage.67682c44.png";